module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Db-Ee.1a175f7a.png";